import { React, useState } from 'react'
import {
  useParams
} from "react-router-dom"
import axios from "axios"
import { baseURL } from "../../store/api/axios.dashboard"


function ForgetPasswordVerify(){
    const { code } = useParams()

    const [message, setMessage] = useState('')
    const [count, setCount] = useState(0)

    const api = (code_pass) => { 

        axios.post(baseURL+"auth/forgetPass/verify", {
            code: code_pass
        }).then((response) => {
            setMessage(response.data.message)
            setCount(1)
            //getAnnouncements()
            //return response
        })
        
    }

    if(count === 0){
        api(code)
    }

    return (
        <div>
            <h1>{message}</h1>
        </div>
    )

}

export default ForgetPasswordVerify